import {
  createApiRef,
  DiscoveryApi,
  IdentityApi,
} from '@backstage/core-plugin-api';

import { AgenticReadinessReport } from '../types';

export interface AgenticReadinessApi {
  getReport(): Promise<AgenticReadinessReport>;
}

export const AgenticReadinessApiRef = createApiRef<AgenticReadinessApi>({
  id: 'plugin.agentic-readiness.service',
});

export class AgenticReadinessApiClient implements AgenticReadinessApi {
  constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly identityApi: IdentityApi,
  ) {}

  async getReport(): Promise<AgenticReadinessReport> {
    const baseUrl = await this.discoveryApi.getBaseUrl('ai-coding-readiness');

    const { token } = await this.identityApi.getCredentials();

    const response = await fetch(`${baseUrl}/report`, {
      headers: {
        Accept: 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch agentic readiness report: ${response.statusText}`,
      );
    }

    return response.json();
  }
}
